// The original six testimonial cards, transcribed from the static PNGs
// (testimonial1-6.png) into editable data so they render as real HTML cards.
// Photos for the first three were cropped out of those PNGs.

export const FEATURED_REVIEWS = [
  {
    name: 'Cintia Bombardieri',
    rating: 5,
    photo: '/assets/testimonial1_photo.jpg',
    text:
      'I recently hired A&M facilities to prepare my house for a new renter. The team did an exceptional job, leaving the entire home spotless. They went above and beyond. Their attention to detail was remarkable, and it gave me peace of mind knowing the place was ready for its next occupant. I highly recommend this cleaning service for anyone in need of a deep, professional clean!',
  },
  {
    name: 'Aline Areias',
    rating: 5,
    photo: '/assets/testimonial2_photo.jpg',
    text:
      "I hired A.M. Facilities to clean my house and I couldn't be happier with the result! The team was extremely professional, punctual and attentive to every detail. My house has never been so clean and organized! The care with which they performed the service exceeded all my expectations. In addition, they were very careful with my furniture and personal belongings. I recommend A.M. Facilities without a doubt and will definitely hire their services again in the future.",
  },
  {
    name: 'Michel Lage',
    rating: 5,
    photo: '/assets/testimonial3_photo.jpg',
    text:
      'I hired AM Facilities, and the service was an absolute breeze. I highly recommend them for businesses like Great Snipe, where quality and excellence are top priorities!',
  },
  {
    name: 'Tâmara Fontenelle',
    rating: 5,
    initials: 'TB',
    text:
      'Careful service to the smallest details. Cleaning and maintenance service carried out brilliantly. The owner Anna is super attentive.',
  },
  {
    name: 'Marcelo Freitas',
    rating: 5,
    subtitle: 'Hired inspection service',
    text:
      "Excellent company!! Service done with great care, really top quality. Very good value for money too. It's worth hiring. Finally, the owner is serious and correct.",
  },
  {
    name: 'Anna Carolina',
    rating: 5,
    text: 'Wonderful result! Excellent quality of services. I recommend it!',
  },
];
